import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { ServiceCRUD } from '../../../shared/crud/ServiceCRUD';

@Injectable()
export class MonitoramentoAcessoriosService extends ServiceCRUD {
  private baseUrlService: string;
  public carregando = true;

  constructor(public httpClient: HttpClient, router: Router, protected toastr: ToastrService) {
    super(httpClient, router);
    this.baseUrlService = environment.URL_API;
  }

  protected getURL(): string {
    return `${this.baseUrlService}/monitoramento_acessorios`;
  }

  public getDados(
    data_inicial?: any,
    data_final?: any,
    dealers?: any,
    origem?: any,
    sub_grupo?: any,
    partNumber?: any,
    documento?: any,
    percentual?: any, filter?: any): Observable<any> {
    return this.httpClient.get<any>(`${this.baseUrlService + '/monitoramento_acessorio/'}`, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': JSON.parse(sessionStorage.getItem('currentUser')).token
      }),
      params: new HttpParams()
        .set('data_inicial', data_inicial.toString())
        .set('data_final', data_final.toString())
        .set('dealers', dealers.toString())
        .set('origem', (origem ?? '').toString())
        .set('sub_grupo', (sub_grupo ?? '').toString())
        .set('partNumber', (partNumber ?? '').toString())
        .set('documento', (documento ?? '').toString())
        .set('percentual', (percentual ?? '').toString())
    });
  }
}
